import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  Card,
  CardContent,
  Chip,
  Fab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  IconButton,
  Divider,
  useTheme,
  alpha
} from '@mui/material';
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Add as AddIcon,
  Save as SaveIcon,
  Close as CloseIcon,
  Business as BusinessIcon,
  MyLocation as TargetIcon,
  Star as StarIcon,
  Group as GroupIcon
} from '@mui/icons-material';
import ValueCard from '../../components/cards/ValueCard';

const SectionCard = ({ title, content, icon, onEdit, showEdit = true, brandColors, editMode }) => (
    <Card 
      elevation={2} 
      sx={{ 
        mb: 3, 
        borderLeft: `4px solid ${brandColors.primary}`,
        '&:hover': { boxShadow: 6 }
      }}
    >
      <CardContent>
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
          <Box display="flex" alignItems="center" gap={1}>
            {icon}
            <Typography variant="h5" sx={{ color: brandColors.dark, fontWeight: 600 }}>
              {title}
            </Typography>
          </Box>
          {editMode && showEdit && (
            <IconButton onClick={onEdit} sx={{ color: brandColors.primary }}>
              <EditIcon />
            </IconButton>
          )}
        </Box>
        <Typography variant="body1" sx={{ lineHeight: 1.7, color: 'text.secondary' }}>
          {content}
        </Typography>
      </CardContent>
    </Card>
  );


  export default SectionCard;